<template>
  <div id="app">
    <router-view v-if="isShow"></router-view>
  </div>
</template>

<script>
import '../static/js/rem'
export default {
  name: 'App',
  data () {
    return {
      // 控制router-view的隐藏与展示
      isShow: true
    }
  },
  // 提供可注入子组件属性
  provide () {
    return {
      reload: this.reload
    }
  },
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享3070, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  methods: {
    reload () {
      // 先隐藏
      this.isShow = false
      // $nextTick() 将回调延迟到下次 DOM 更新循环之后执行
      this.$nextTick(() => {
        this.isShow = true
      })
    }
  }
}
</script>

<style   lang="scss">
/* @import url('../static/css/reset'); */
@import "./assets/diy.scss"; //之前登录的样式
@import "./assets/PersonalCenter.scss";
@import "./assets/css/login.scss";
#app {
  width: 100%;
  height: 100%;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue